import { ChapterManage } from './ChapterManage'
import { withChapterManage } from './withChapterManage'

const ConnectedChapterManage = withChapterManage(ChapterManage)

export { ConnectedChapterManage as ChapterManage }
